export const UspLookupTypeIdEnum = {
  lookupTypeId: 2153,
};
